import React from "react";
import { useParams } from "react-router-dom"; // For dynamic routing
import PropertyDetails from "../components/PropertyDetails";

const PropertyDetailsPage = () => {
  const { propertyId } = useParams(); // Retrieve propertyId from URL params
  const property = getPropertyById(propertyId); // Get property data from a function or API call

  return (
    <div className="container mx-auto py-16">
      <PropertyDetails
        title={property.title}
        image={property.image}
        price={property.price}
        location={property.location}
        description={property.description}
        features={property.features}
      />
    </div>
  );
};

// Example function to get property by ID (replace with real data fetching)
const getPropertyById = (id) => {
  const properties = [
    {
      id: 1,
      title: "Luxury Villa",
      image: "https://via.placeholder.com/600x400",
      price: "2500/month",
      location: "Miami, FL",
      description: "A beautiful luxury villa with modern amenities.",
      features: ["3 Bedrooms", "2 Bathrooms", "Swimming Pool"],
    },
  ];
  return properties.find((property) => property.id === parseInt(id));
};

export default PropertyDetailsPage;
